import { set, when, unset } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'
import isNewNodeSelected from '../actions/isNewNodeSelected'
import loadMediaFiles from 'modules/Media/chains/loadMediaFiles'
import selectTreeNodes from '../actions/selectTreeNodes'
import deselectAllFiles from 'modules/Media/chains/deselectAllFiles'

export default [
  unset(state`media.latestSearchCriteria`),
  isNewNodeSelected,
  {
    true: [
      ...deselectAllFiles,
      selectTreeNodes,
      set(state`node.selectedNode.id`, props`id`),
      set(state`node.selectedNode.path`, props`path`),
      set(state`node.rebuildTree`, true),
      loadMediaFiles
    ],
    false: []
  },
  when(state`app.currentView`, view => view !== 'media'),
  {
    true: [set(state`app.currentView`, 'media')],
    false: []
  },
  set(state`startPage.latest`, false),
  set(state`app.showSort`, true)
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/selectNode.js